import React from 'react';

import LotteryTicket from '../../../Api/Models/LotteryTicket';
import * as formatters from '../../../utils/formatters';
import ActionButton from '../../elements/ActionButton';
import ColoredStatus from '../../elements/common/ColoredStatus';
import TableHead from '../../elements/common/TableHead';
import { PERMISSION } from '../../helpers/Permissions';

function TicketsTableShort({ tickets }: { tickets: LotteryTicket[] }) {
    const { formatCurrency } = formatters;

    function getTicketsList() {
        return tickets.map((ticket) => (
            <tr key={ticket.id}>
                <td>{ticket.token}</td>
                <td>
                    <ColoredStatus status={ticket.status} />
                </td>
                <td>{formatCurrency(ticket.system_sell_amount_gross)}</td>
                <td>
                    <ActionButton title="open" url={`/tickets/${ticket.id}`} permissions={[PERMISSION.VIEW_TICKET]} />
                </td>
            </tr>
        ));
    }

    return (
        <table className="table">
            <TableHead>
                <th>Token</th>
                <th>Status</th>
                <th>Amount (gross)</th>
                <div />
            </TableHead>
            <tbody>{getTicketsList()}</tbody>
        </table>
    );
}

export default TicketsTableShort;
